import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zhengjianguanli-h",
  "use": "icon-zhengjianguanli-h-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-zhengjianguanli-h\">\n  <path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\" />\n  <polyline points=\"14 2 14 8 20 8\" />\n  <line x1=\"9\" y1=\"15\" x2=\"15\" y2=\"15\" />\n  <line x1=\"9\" y1=\"11\" x2=\"15\" y2=\"11\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zhengjianguanli-h.svg
// module id = ME/a
// module chunks = 101